/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/button-has-type */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import fetchBooks from '../../../../redux/bookStore/thunk/fetchBooks';
import BookList from './Booklist/Booklist';

function BookLists() {
  const books = useSelector(state => state.books);
  const status = useSelector(state => state.status);
  const { filterFeature, searchText } = status;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBooks);
  }, [dispatch]);
  return (
    <div className="lws-bookContainer">
      
      {books.length > 0 ? (
        filterFeature ? (
          books.map(bookItem => {
            if (
              bookItem.featured &&
              bookItem.name.toLowerCase().includes(searchText.toLowerCase())
            )
              return <BookList key={bookItem.id} bookItem={bookItem} />;
          })
        ) : (
          books.map(bookItem => {
            if (bookItem.name.toLowerCase().includes(searchText.toLowerCase()))
              return <BookList key={bookItem.id} bookItem={bookItem} />;
          })
        )
      ) : (
        <h1>No book found</h1>
      )}
    </div>
  );
}

export default BookLists;
